<template>
    <div class="inquiry">
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
            :breadcrumb="{ props: { routes } }"
        />

        <div class="inquiry-detail">
            <a-card>
                <div>
                    <a-tabs default-active-key="1">
                        <a-tab-pane key="1" tab="留言信息">
                            <div class="clear-btn">
                                <a-button type="primary" @click="clear">清除未读</a-button>
                            </div>
                            <a-table
                            :columns="columns"
                            :pagination="pagination"
                            :loading="loading"
                            @change="handleTableChange"
                            :data-source="data"

                            >
                                <span slot="status" slot-scope="status">
                                <a-badge
                                :status="status === 1 ? 'processing' : 'error'"
                                />    
                                <span v-if="status==1">已读</span>
                                <span v-if="status==2">未读</span>
                            </span>

                            <span slot="action" slot-scope="text, record">
                                <a href="javascript:;" @click="detail" :id="record.id"><a-icon  type="file-search"/>查看</a>
                            </span>
                            </a-table>
                        </a-tab-pane>
                        <!-- <a-tab-pane key="2" tab="在线客服" force-render>
                            <a-table
                            :columns="columns2"
                            :pagination="pagination"
                            :loading="loading"
                            @change="handleTableChange"
                            :data-source="data2"
                            >
                            <span slot="action2">
                                <a href="javascript:;" @click="chat"><a-icon type="file-search"/>查看</a>
                            </span>
                            </a-table>
                        </a-tab-pane> -->
                    </a-tabs>
                </div>
            </a-card>
        </div>

        <a-modal v-model="tipvisible" width="700px" :centered="true"  title="留言详情"  class="tipdeatil">
          <a-row>
              <a-col :span="12">
              <a-row>
                  <a-col :span="6">
                  <label>公司名：</label>
                  </a-col>
                  <a-col :span="18">
                  <a-input :value="form.company" :disabled='true'/>
                  </a-col>
              </a-row>
              </a-col>
              <a-col :span="12">
              <a-row>
                  <a-col :span="6">
                  <label>留言时间：</label>
                  </a-col>
                  <a-col :span="18">
                  <a-input :value="form.create_time" :disabled='true'/>
                  </a-col>
              </a-row>
              </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>客户名：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.name" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>联系电话：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.phone" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>邮箱：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.email" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>来源IP：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.ip" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>留言入口：</label>
                </a-col>
                <a-col :span="18">
                <a-input value="飞象宝" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>来源地区：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.area" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
            <a-row>
                <a-col :span="3">
                <label>页面路径：</label>
                </a-col>
                <a-col :span="21">
                <a-input :value="form.page" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
            <a-row>
                <a-col :span="3">
                <label>留言内容：</label>
                </a-col>
                <a-col :span="21">
                <a-textarea :value="form.content" placeholder="" :rows="4" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>
        </a-modal>

        <!-- <a-modal v-model="chatvisible" width="800px" :centered="true"  title="聊天列表"  class="tipdeatil">
          <a-table
            :columns="columns3"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            :data-source="data3"
            >
          </a-table>
        </a-modal> -->
    </div>
</template>

<script>

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
    {
    title: '留言时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
    {
    title: '客户',
    key: 'name',
    dataIndex: 'name',

  },
    {
    title: '联系电话',
    key: 'phone',
    dataIndex: 'phone',

  },

  {
    title: '留言内容',
    dataIndex: 'content',
    key: 'content',
  },
  {
    title: '留言入口',
    key: 'place',
    dataIndex: 'place',
  },

  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    filters: [
      { text: '未读', value: '2' },
      { text: '已读', value: '1' },
    ],
    filterMultiple: false,
    scopedSlots: { customRender: 'status' },

  },

  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

const columns2 = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '客户ID号',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '首次咨询时间',
    dataIndex: 'address',
    key: 'address',
    sorter: (a, b) => a.address - b.address,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '最新咨询内容',
    key: 'tags',
    dataIndex: 'tags',
  },
  {
    title: '最新咨询时间',
    key: 'url',
    dataIndex: 'url',
    sorter: (a, b) => a.url - b.url,
    sortDirections: ['descend', 'ascend'],

  },
  {
    title: '操作',
    dataIndex: 'action2',
    scopedSlots: { customRender: 'action2' },
  },
];

const columns3 = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '类别',
    dataIndex: 'age',
    key: 'age',
  },
   {
    title: '内容类别',
    dataIndex: 'address',
    key: 'address',
  },
   {
    title: '时间',
    dataIndex: 'tags',
    key: 'tags',
  },
];

const data3 = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address:'1323598412',
    tags:'2020-09-12 12:32:56'
  },
]
const data2 = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: '钢化玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'未读',
    money:'26',
  },
]

export default {
    data(){
        return{
            tipvisible:false,
            chatvisible:false,
            data:"",
            data2,
            data3,
            columns,
            columns2,
            columns3,
            pagination: {},
            loading: false,
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '自有询盘'},
            ],
            form:{
                name:""
            },
            currentpagination:"",
            currentfilters:"",
            currentsorter:""
        }
    },
    mounted(){
    //   this.$axios.get('/api/getvoicelist',{
    //       headers: {
    //           "appid": this.appSet.appid,
    //           "appkey": this.appSet.appkey,
    //           "token":localStorage.getItem('token'),
    //       }
    //   }).then((res)=>{
    //       if(res.data.code==200){
    //           this.data=res.data.data.lists
    //       }
    //   })
        this.fetch();
    },
    methods:{
      clear(){
        this.$axios.get('/api/clearvoice',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
              this.$message.success('清除成功');
              var params=""
              params.page
                this.fetch({
                    limits: this.currentpagination.pageSize,
                    page: this.currentpagination.current,
                    sortField: this.currentsorter.field,
                    sortOrder: this.currentsorter.order,
                    ...this.currentfilters,
                });
            }
        })
      },
      detail(event){
        this.tipvisible=true
        var id=event.currentTarget.id
        this.$axios.get('/api/getvoicedetail',{
          headers: {
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
          params:{
            id:id
          }
      }).then((res)=>{
          if(res.data.code==200){
            this.form=res.data.data
            this.fetch({
                limits: this.currentpagination.pageSize,
                page: this.currentpagination.current,
                sortField: this.currentsorter.field,
                sortOrder: this.currentsorter.order,
                ...this.currentfilters,
            });
            //   this.$axios.get('/api/getvoicelist',{
            //       headers: {
            //           "appid": this.appSet.appid,
            //           "appkey": this.appSet.appkey,
            //           "token":localStorage.getItem('token'),
            //       }
            //   }).then((res)=>{
            //       if(res.data.code==200){
            //           this.data=res.data.data.lists
            //       }
            //   })
          }
      })
      },
      chat(){
        this.chatvisible=true
      },
      handleTableChange(pagination, filters, sorter) {
        console.log("pagination="+pagination);
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.currentpagination=pagination
        this.currentfilters=filters
        this.currentsorter=sorter
        this.fetch({
            limits: pagination.pageSize,
            page: pagination.current,
            sortField: sorter.field,
            sortOrder: sorter.order,
            ...filters,
        });
      },

      fetch(params = {}) {
            console.log('params:', params);

            if(params.status){
                params.status=params.status[0]
            }
  
            this.loading = true;
            this.$axios.get('/api/getvoicelist',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    var data=res.data.data.lists
                    if(data.length>0){
                        for(var i in data){
                            data[i].place="飞象宝"
                        }
                    }
                    this.data=data;
                    
                    this.loading = false;
                    this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/inquiry/index.vue